wbApp.directive('wbPersonalIdNumberValidator', [function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {
            scope.$watch(attr.ngModel, function (model) {
                
                // https://lorenc.info/3MA381/overeni-spravnosti-rodneho-cisla.htm#6
                let isValid = true;
                if (!!model) {
                    const parsed = parseInt(model, 10);
                    if (isNaN(parsed)) {
                        isValid = false;
                    } else {
                        if (model.length === 10) {
                            isValid = (parsed % 11) === 0;
                        } else if (model.length === 9) {
                            isValid = parsed < 540000000;
                        } else {
                            isValid = false;
                        }
                    }
                }

                ctrl.$setValidity('pattern', isValid);
            });
        }
    };
}]);
